import newAddressTypeahead from './new-address-typeahead.vue'

export default newAddressTypeahead
